import { useTranslation } from 'react-i18next';
import React from 'react';
import OpenSlotControls from './OpenSlotControls';

/**
 * Final connect step showing server info, map hero, and Steam connect button.
 *
 * For live 5v5 matches it also renders the backfill control (OpenSlotControls)
 * so a participant can open a free slot when someone has to leave.
 */
export default function StepConnect({ match, connectInfo, steamLink }) {
  const { t } = useTranslation();
  return (
    <div className="step-content lobby-connect">
      {match?.maplist?.[0] && (
        <div className="connect-map-hero">
          <img
            className="connect-map-img"
            src={`/stats/images/maps/${match.maplist[0]}.${match.maplist[0] === 'de_train' ? 'png' : 'jpg'}`}
            alt=""
          />
          <div className="connect-map-overlay">
            <span className="connect-map-name">
              {(() => {
                const tag = match.maplist[0];
                const name = match.maps?.find(m => m.tag === tag)?.name;
                if (name) return name;
                return tag.startsWith('de_') ? tag.replace('de_', '').charAt(0).toUpperCase() + tag.replace('de_', '').slice(1) : tag;
              })()}
            </span>
          </div>
        </div>
      )}
      <h2>{t('createMatch.serverReady')}</h2>
      <p className="connect-teams">
        {match?.team1?.name || 'Team 1'} vs {match?.team2?.name || 'Team 2'}
      </p>
      {steamLink && (
        <a href={steamLink} className="steam-connect-btn">
          {t('createMatch.connectSteam')}
        </a>
      )}
      <p className="connect-hint">{t('createMatch.connectHint')}</p>
      <div className="connect-box">
        <code>{connectInfo}</code>
        <button
          className="copy-btn"
          onClick={() => navigator.clipboard.writeText(connectInfo)}
        >
          {t('createMatch.copy')}
        </button>
      </div>
      <OpenSlotControls match={match} />
    </div>
  );
}
